import { withInstall } from '@vuemap/vue-amap-util'
import ElasticMarker from './ElasticMarker.vue'

export const ElAmapElasticMarker = withInstall(ElasticMarker)
export default ElAmapElasticMarker
